import { Component, OnInit,Input } from '@angular/core';
import { ConsultarPreguntasService } from "../../administrador-preguntas/consultar-preguntas.service";
import { Globals } from "src/app/globals";
import Swal from "sweetalert2";
import { OkFrontPreguntasComponent } from "../../administrador-preguntas/ok-front-preguntas.component";

@Component({
  selector: 'app-actualizador-preguntas',
  templateUrl: './actualizador-preguntas.component.html',
  styleUrls: ['./actualizador-preguntas.component.css']
})
export class ActualizadorPreguntasComponent implements OnInit {

  @Input() tipoPregunta: number;

  constructor(private ConsultarPreguntas: ConsultarPreguntasService ,public global: Globals,private okFrontPreguntasComponent: OkFrontPreguntasComponent) { }


  TituloEspanol;
  SubtituloEspanol;
  DescripcionPreguntaEspanol;
  sideclarasteEspanol;
  InstruccionesllenadoEspanol;  
  Texto1ES;  
  Texto2ES;  
  Texto3ES;  
  Texto4ES;  
  Texto5ES;
  
  TituloIngles;
  SubtituloIngles;
  DescripcionPreguntaIngles;
  sideclarasteIngles;
  InstruccionesllenadoIngles;
  Texto1EN;
  Texto2EN;
  Texto3EN;
  Texto4EN;
  Texto5EN;
  listaRespuestas=[];

  valorRespuestaES
  valorRespuestaEN
  respuestaCorrecta;
  

  ngOnInit() {

    //////conole.log(this.tipoPregunta);

    this.ConsultarTodasLasPreguntas();

  }


  ConsultarTodasLasPreguntas() {
    this.listaRespuestas=[]
    
    this.ConsultarPreguntas.ConsultarPregunta(this.tipoPregunta).subscribe(ArrayResultados => {
    

      this.TituloEspanol = ArrayResultados[0].tipo_conflicto_espanol;
      this.SubtituloEspanol = ArrayResultados[0].nombre;
      this.DescripcionPreguntaEspanol = ArrayResultados[0].DescripcionPregunta;           

      this.sideclarasteEspanol = ArrayResultados[0].sideclarasteEspanol;  

      

      this.InstruccionesllenadoEspanol = ArrayResultados[0].Instruccionesllenado;  
      this.Texto1ES = ArrayResultados[0].Texto1ES;  
      this.Texto2ES = ArrayResultados[0].Texto2ES;  
      this.Texto3ES = ArrayResultados[0].Texto3ES;  
      this.Texto4ES = ArrayResultados[0].Texto4ES;  
      this.Texto5ES = ArrayResultados[0].Texto5ES;  
      

      this.TituloIngles = ArrayResultados[0].tipo_conflicto_ingles;
      this.SubtituloIngles = ArrayResultados[0].ingles;
      this.DescripcionPreguntaIngles = ArrayResultados[0].InglesDescripcionPregunta;   
      
      this.sideclarasteIngles = ArrayResultados[0].sideclarasteIngles;   
      
      

      this.InstruccionesllenadoIngles = ArrayResultados[0].InstruccionesllenadoIngles;  
      this.Texto1EN = ArrayResultados[0].Texto1EN;  
      this.Texto2EN = ArrayResultados[0].Texto2EN;  
      this.Texto3EN = ArrayResultados[0].Texto3EN;  
      this.Texto4EN = ArrayResultados[0].Texto4EN;  
      this.Texto5EN = ArrayResultados[0].Texto5EN;     
      
     

      

      if(this.Texto1ES!=null && this.Texto1ES!="  " && this.Texto1ES!=" "){
        this.listaRespuestas.push({'respuesta':"Texto 1"});
      }

      if(this.Texto2ES!=null && this.Texto2ES!="  " && this.Texto2ES!=" "){
        this.listaRespuestas.push({'respuesta':"Texto 2"});
      }

      if(this.Texto3ES!=null && this.Texto3ES!="  " && this.Texto3ES!=" "){
        this.listaRespuestas.push({'respuesta':"Texto 3"});
      }

      if(this.Texto4ES!=null && this.Texto4ES!="  " && this.Texto4ES!=" "){
        this.listaRespuestas.push({'respuesta':"Texto 4"});
      }

      if(this.Texto5ES!=null && this.Texto5ES!="  " && this.Texto5ES!=" "){
        this.listaRespuestas.push({'respuesta':"Texto 5"});
      }

      //console.log(this.listaRespuestas)
      
      this.ConsultarPreguntas.ConsultarRespuestaCorrecta(this.tipoPregunta).subscribe(rt=>{
       
          if(rt){

         
        if(rt['texto_es']==this.Texto1ES && rt['texto_en']==this.Texto1EN){
          this.respuestaCorrecta="Texto 1"
        }

        if(rt['texto_es']==this.Texto2ES && rt['texto_en']==this.Texto2EN){
          this.respuestaCorrecta="Texto 2"
        }

        if(rt['texto_es']==this.Texto3ES && rt['texto_en']==this.Texto3EN){
          this.respuestaCorrecta="Texto 3"
        }

        if(rt['texto_es']==this.Texto4ES && rt['texto_en']==this.Texto4EN){
          this.respuestaCorrecta="Texto 4"
        }

        if(rt['texto_es']==this.Texto5ES && rt['texto_en']==this.Texto5EN){
          this.respuestaCorrecta="Texto 5"
        }
      }

        //console.log("RESPUESTA CORRECTA",this.respuestaCorrecta)

      })

    });

    
  }


  ActualizarPregunta(){


    //////conole.log("actualiza pregunta");

    this.ConsultarPreguntas.ActualizarPregunta(
      this.tipoPregunta,
      this.TituloEspanol,
      this.SubtituloEspanol,
      this.DescripcionPreguntaEspanol,
      this.InstruccionesllenadoEspanol,
      this.TituloIngles,
      this.SubtituloIngles,
      this.DescripcionPreguntaIngles,
      this.InstruccionesllenadoIngles,
      this.Texto1ES,
      this.Texto1EN,
      this.Texto2ES,
      this.Texto2EN,
      this.Texto3ES,
      this.Texto3EN,
      this.Texto4ES,
      this.Texto4EN,
      this.Texto5ES,
      this.Texto5EN,
      this.sideclarasteEspanol,
      this.sideclarasteIngles,
      this.valorRespuestaES,
      this.valorRespuestaEN,
      
      ).subscribe(ArrayResultados => {
    
//////conole.log(ArrayResultados);

      Swal.fire("Actualizado!", "Se actualizaron los textos de la pregunta", "success");
      
      this.okFrontPreguntasComponent.ConsultarTodasLasPreguntas(this.global.PreguntaActual);
      this.global.PrincipalAdministradorpreguntas = true;
      this.global.ActualizarPregunta = false;

    });




  }


  Volver(){
    
    this.global.PrincipalAdministradorpreguntas = true;
    this.global.ActualizarPregunta = false;
    
  }

  enviarRespuesta(valor){
    //console.log(valor)
    this.respuestaCorrecta=valor
    if(valor=="Texto 1"){
      this.valorRespuestaES=this.Texto1ES
      this.valorRespuestaEN=this.Texto1EN
    }

    if(valor=="Texto 2"){
      this.valorRespuestaES=this.Texto2ES
      this.valorRespuestaEN=this.Texto2EN
    }

    if(valor=="Texto 3"){
      this.valorRespuestaES=this.Texto3ES
      this.valorRespuestaEN=this.Texto3EN
    }

    if(valor=="Texto 4"){
      this.valorRespuestaES=this.Texto4ES
      this.valorRespuestaEN=this.Texto4EN
    }

    if(valor=="Texto 5"){
      this.valorRespuestaES=this.Texto5ES
      this.valorRespuestaEN=this.Texto5EN
    }
    
  }

}
